import {
  reqGetDevices,
  reqGetDevice,
  reqGetDeviceInfo,
  reqDeleteDevice,
  reqSaveDevice,
  reqOnlineDevice,
  reqGetLatestTimeseries,
  reqGetTimeseries,
  reqGetHomeDevicesTs,
  reqGetHomeDevicesTs1,
  reqGetCustomerDevices,
  reqGetDevicesCount,
  reqGetDevicesFindLocal,
  reqAssignDeviceToCustomer,
  reqUnassignDeviceFromCustomer,
  reqCreateElectricFence,
  reqDeleteElectricFence,
  reqCreateAlarmMode,
  reqGetAllDevices,
  reqGetAllDevices1,
  reqFindDeviceB1ByImei,
  reqFindDevicesB1,
  reqFindDevicesByError,
} from "@/api/api.js";
import * as XLSX from "xlsx";

const state = {
  devicesList: [],
  devicesInfo: [],
  devicesFind: [],
  deviceFindInfo: [],
  onlineDeviceInfo: [],
  latestTimeseries: [],
  timeseries: [],
  homeDevicesTs: [],
  deviceTs: [],
  customerDevicesList: [],
  customerDevicesInfo: [],
  devicesCount: 0,
  devicesFindLocal: [],
  deviceNameFindByNumber: "",
  allDevicesB1: [],
  findDevicesB1: [],
  arr: [],
  findErrorDevices: [],
};
const mutations = {
  GETDEVICESLIST(state, devicesList) {
    state.devicesList = devicesList;
  },
  GETDEVICESINFO(state, devicesInfo) {
    state.devicesInfo = devicesInfo;
    state.homeDevicesTs = [];
  },
  GETDEVICESFIND(state, devicesFind) {
    state.devicesFind = devicesFind;
  },
  GETDEVICEFINDINFO(state, deviceFindInfo) {
    state.deviceFindInfo = deviceFindInfo;
  },
  ONLINEDEVICE(state, onlineDeviceInfo) {
    state.onlineDeviceInfo = onlineDeviceInfo;
  },
  GETLATESTTIMESERIES(state, latestTimeseries) {
    state.latestTimeseries = latestTimeseries;
  },
  GETHOMEDEVICESTS(state, homeDevicesTs) {
    state.homeDevicesTs = homeDevicesTs;
  },
  GETTIMESERIES(state, deviceTs) {
    state.deviceTs = deviceTs;
  },
  GETCUSTOMERDEVICESLIST(state, customerDevicesList) {
    state.customerDevicesList = customerDevicesList;
  },
  GETCUSTOMERDEVICESINFO(state, customerDevicesInfo) {
    state.customerDevicesInfo = customerDevicesInfo;
  },
  GETDEVICESCOUNT(state, devicesCount) {
    state.devicesCount = devicesCount;
  },
  GETDEVICESFINDLOCAL(state, devicesFindLocal) {
    state.devicesFindLocal = devicesFindLocal;
    state.deviceNameFindByNumber = devicesFindLocal;
  },
  GETDEVICEFINDBYNUMBER(state, deviceNameFindByNumber) {
    state.deviceNameFindByNumber =
      deviceNameFindByNumber[0].latest.ENTITY_FIELD.name.value;
  },
  GETALLDEVICES(state, allDevicesB1) {
    state.allDevicesB1 = allDevicesB1;
  },
  GETFINDDEVICEB1BYIMEI(state, findDevicesB1) {
    state.findDevicesB1 = findDevicesB1;
  },
  GETFINDDEVICESBYERROR(state, findErrorDevices) {
    state.findErrorDevices = findErrorDevices;
  },
};
const actions = {
  async getDevicesList({ commit }, params = {}) {
    let result = await reqGetDevices(params);
    // let arr = [];
    // result.data.data.forEach((r) => {
    //   let obj = {
    //     imei: r.name,
    //     id: r.id.id,
    //   };
    //   arr.push(obj);
    // });
    // const wb = XLSX.utils.book_new();
    // // 创建一个工作表
    // const ws = XLSX.utils.json_to_sheet(arr);

    // // 将工作表添加到工作簿
    // XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // // 将工作簿写入文件
    // XLSX.writeFile(wb, "output.xlsx");
    if (result.status === 200) {
      commit("GETDEVICESLIST", result.data);
      commit("GETDEVICESINFO", result.data.data);
    }
  },
  async deleteDevice({ commit }, id) {
    let result = await reqDeleteDevice(id);
    if (result.status === 200) {
      return "ok";
    }
  },
  async getDevicesFind({ commit }, params = {}) {
    let result = await reqGetDevice(params);
    if (result.status === 200) {
      commit("GETDEVICESFIND", result.data);
    }
  },
  async getDeviceFindInfo({ commit }, params = {}) {
    let result = await reqGetDeviceInfo(params);
    if (result.status === 200) {
      commit("GETDEVICEFINDINFO", result.data);
    }
  },
  async saveDevice({ commit }, data) {
    let result = await reqSaveDevice(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async onlineDevice({ commit }, data) {
    let result = await reqOnlineDevice(data);
    if (result.status === 200) {
      commit("ONLINEDEVICE", result.data.data);
    }
  },
  async getLatestTimeseries({ commit }, data) {
    let result = await reqGetLatestTimeseries(data);
    if (result.status === 200) {
      commit("GETLATESTTIMESERIES", result.data);
    }
  },
  async getHomeDevicesTs({ commit }, data) {
    let result = await reqGetHomeDevicesTs(data);
    if (result.status === 200) {
      result.data.name = data.name;
      result.data.device_type = "电池包";
      result.data.entityId = data.entityId;
      commit("GETHOMEDEVICESTS", result.data);
    }
  },

  // async getHomeDevicesTs1({ commit }, data) {
  //   let result = await reqGetHomeDevicesTs1(data);
  //   result.data.name = data.name;
  //   let out = "";
  //   let value = result.data.PACK_SN[0].value;
  //   if (value === "N303030303030303030303030303030303030303030303030") {
  //     out = "";
  //   } else {
  //     var first = value.charAt(0);
  //     if (first == "N") {
  //       value = value.substring(1, value.length);
  //     }
  //     var hex = value;
  //     var arrt = hex.split("");
  //     for (var i = 0; i < arrt.length / 2; i++) {
  //       var tmp = "0x" + arrt[i * 2] + arrt[i * 2 + 1];
  //       var charValue = String.fromCharCode(tmp);
  //       out += charValue;
  //     }
  //   }

  //   state.arr.push([result.data.name, out]);
  //   // if (result.status === 200) {
  //   //   result.data.name = data.name;
  //   //   result.data.device_type = "电池包";
  //   //   result.data.entityId = data.entityId;
  //   //   commit("GETHOMEDEVICESTS", result.data);
  //   // }
  //   if (state.arr.length === 3353) {
  //     const wb = XLSX.utils.book_new();
  //     // 创建一个工作表
  //     const ws = XLSX.utils.json_to_sheet(state.arr);

  //     // 将工作表添加到工作簿
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //     // 将工作簿写入文件
  //     XLSX.writeFile(wb, "output.xlsx");
  //   }
  // },

  async getTimeseries({ commit }, data) {
    let result = await reqGetTimeseries(data);
    if (result.status === 200) {
      commit("GETTIMESERIES", result.data);
    }
  },
  async getCustomerDevices({ commit }, params = {}) {
    let result = await reqGetCustomerDevices(params);
    // let arr = [];
    // result.data.data.forEach((r) => {
    //   let obj = {
    //     imei: r.name,
    //     id: r.id.id,
    //   };
    //   arr.push(obj);
    // });
    // const wb = XLSX.utils.book_new();
    // // 创建一个工作表
    // const ws = XLSX.utils.json_to_sheet(arr);

    // // 将工作表添加到工作簿
    // XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // // 将工作簿写入文件
    // XLSX.writeFile(wb, "output.xlsx");
    if (result.status === 200) {
      result.data.data.customerTitle = params.customerTitle;
      commit("GETCUSTOMERDEVICESLIST", result.data);
      commit("GETCUSTOMERDEVICESINFO", result.data.data);
    }
  },
  async getDevicesCount({ commit }, params = {}) {
    let result = await reqGetDevicesCount(params);
    if (result.status === 200) {
      commit("GETDEVICESCOUNT", result.data);
    }
  },
  async getDevicesFindLocal({ commit }, params = {}) {
    let result = await reqGetDevicesFindLocal(params);
    if (result.status === 200) {
      commit("GETDEVICESFINDLOCAL", result.data.data);
    }
  },
  async getDeviceFindByNumber({ commit }, params = {}) {
    let result = await reqGetDevicesFindLocal(params);
    if (result.status === 200) {
      commit("GETDEVICEFINDBYNUMBER", result.data.data);
    }
  },
  async assignDeviceToCustomer({ commit }, data) {
    let result = await reqAssignDeviceToCustomer(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async unassignDeviceFromCustomer({ commit }, data) {
    let result = await reqUnassignDeviceFromCustomer(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async createElectricFence({ commit }, data) {
    let result = await reqCreateElectricFence(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async deleteElectricFence({ commit }, data) {
    let result = await reqDeleteElectricFence(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async createAlarmMode({ commit }, data) {
    let result = await reqCreateAlarmMode(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async getAllDevices({ commit }, data) {
    let result;
    if (data.customerTitle) {
      result = await reqGetAllDevices1(data);
      result.data.data.customerTitle = data.customerTitle;
    } else {
      data = {
        page: data.page,
        pageSize: data.pageSize,
      };
      result = await reqGetAllDevices(data);
    }
    if (result.status === 200) {
      commit("GETALLDEVICES", result.data.data);
    }
  },
  async findDeviceB1ByImei({ commit }, data) {
    let result = await reqFindDeviceB1ByImei(data);
    if (result.status === 200) {
      commit("GETFINDDEVICEB1BYIMEI", result.data.data);
    }
  },
  async findDevicesByError({ commit }, data) {
    let result = await reqFindDevicesByError(data);
    if (result.status === 200) {
      commit("GETFINDDEVICESBYERROR", result.data.data);
    }
  },
};

// function timeFormat(date){
//       var y = date.getFullYear();
//       var m = date.getMonth() + 1;
//       var d = date.getDate();
//       d = d < 10 ? "0" + d : d;
//       var h = date.getHours();
//       h = h < 10 ? "0" + h : h;
//       var min = date.getMinutes();
//       min = min < 10 ? "0" + min : min;
//       var s = date.getSeconds();
//       s = s < 10 ? "0" + s : s;
//       var str =
//         y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
//         return str;
// };

const getters = {
  devicesList(state) {
    return state.devicesList || [];
  },
  devicesInfo(state) {
    for (let i = 0; i < state.devicesInfo.length; i++) {
      const date = new Date(state.devicesInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.devicesInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.devicesInfo || [];
  },
  devicesFind(state) {
    const date = new Date(state.devicesFind.createdTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var min = date.getMinutes();
    min = min < 10 ? "0" + min : min;
    var s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    state.devicesFind.createdTime =
      y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    return state.devicesFind || [];
  },
  deviceFindInfo(state) {
    const date = new Date(state.deviceFindInfo.createdTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var min = date.getMinutes();
    min = min < 10 ? "0" + min : min;
    var s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    state.deviceFindInfo.createdTime =
      y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    return state.deviceFindInfo || [];
  },
  latestTimeseries(state) {
    var arr = state.latestTimeseries;
    var newArr = [];
    for (var k in arr) {
      for (var p in arr[k]) {
        const date = new Date(arr[k][p].ts);
        var y = date.getFullYear(); // 年份z
        var m = date.getMonth() + 1; // 月份
        var d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        var h = date.getHours(); // 小时
        h = h < 10 ? "0" + h : h;
        var min = date.getMinutes(); // 分钟
        min = min < 10 ? "0" + min : min;
        var s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        arr[k][p].ts = y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
        var obj = new Object();
        obj.ts = arr[k][p].ts;
        obj.keys = k;
        obj.value = arr[k][p].value;
        obj.isChecked = false;
        newArr.push(obj);
      }
    }
    state.latestTimeseries = newArr;
    return state.latestTimeseries || [];
  },
  homeDevicesTs(state) {
    // 1、BMS_pcbBatch
    if (state.homeDevicesTs.hasOwnProperty("BMS_pcbBatch")) {
      var value = state.homeDevicesTs.BMS_pcbBatch[0].value;
      if (value === "N000000000000") {
        state.homeDevicesTs.BMS_pcbBatch[0].value = "";
      } else {
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var i = 0; i < arr.length / 2; i++) {
          var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.homeDevicesTs.BMS_pcbBatch[0].value = out;
      }
    }

    // 、PACK_SN
    if (state.homeDevicesTs.hasOwnProperty("PACK_SN")) {
      var value = state.homeDevicesTs.PACK_SN[0].value;
      if (
        value === "N303030303030303030303030303030303030303030303030" ||
        value === "N000000000000000000000000000000000000"
      ) {
        state.homeDevicesTs.PACK_SN[0].value = "";
      } else {
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var i = 0; i < arr.length / 2; i++) {
          var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.homeDevicesTs.PACK_SN[0].value = out;
      }
    }

    // 2、Battery_Status
    if (state.homeDevicesTs.hasOwnProperty("Battery_Status")) {
      var value = state.homeDevicesTs.Battery_Status[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.Battery_Status[0].value = value;
    }
    // chargeFlag
    if (state.homeDevicesTs.hasOwnProperty("chargeFlag")) {
      var value = state.homeDevicesTs.chargeFlag[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      state.homeDevicesTs.chargeFlag[0].value = value;
    }
    // 3、HARD_4G
    if (state.homeDevicesTs.hasOwnProperty("HARD_4G")) {
      var value = state.homeDevicesTs.HARD_4G[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.HARD_4G[0].value = value;
    }

    // 4、HARD_BMS
    if (state.homeDevicesTs.hasOwnProperty("HARD_BMS")) {
      var value = state.homeDevicesTs.HARD_BMS[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.HARD_BMS[0].value = value;
    }

    // 4、SOFT_BMS
    if (state.homeDevicesTs.hasOwnProperty("SOFT_BMS")) {
      var value = state.homeDevicesTs.SOFT_BMS[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.SOFT_BMS[0].value = value;
    }

    // 5、SIM_ICCID
    if (state.homeDevicesTs.hasOwnProperty("SIM_ICCID")) {
      var value = state.homeDevicesTs.SIM_ICCID[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var hex = value;
      var arr = hex.split("");
      var out = "";
      for (var i = 0; i < arr.length / 2; i++) {
        var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
        var charValue = String.fromCharCode(tmp);
        out += charValue;
      }
      state.homeDevicesTs.SIM_ICCID[0].value = out;
    }

    // 6、SIM_IMSI
    if (state.homeDevicesTs.hasOwnProperty("SIM_IMSI")) {
      var value = state.homeDevicesTs.SIM_IMSI[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var hex = value;
      var arr = hex.split("");
      var out = "";
      for (var i = 0; i < arr.length / 2; i++) {
        var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
        var charValue = String.fromCharCode(tmp);
        out += charValue;
      }
      state.homeDevicesTs.SIM_IMSI[0].value = out;
    }

    // 7、SOFT_4G
    if (state.homeDevicesTs.hasOwnProperty("SOFT_4G")) {
      var value = state.homeDevicesTs.SOFT_4G[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.SOFT_4G[0].value = value;
    }

    // 8、altitude
    if (state.homeDevicesTs.hasOwnProperty("altitude")) {
      var value = state.homeDevicesTs.altitude[0].value;
      if (value === "0") {
        state.homeDevicesTs.altitude[0].value = 0;
      } else {
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.homeDevicesTs.altitude[0].value = value;
      }
    }

    // 9、battery_type
    if (state.homeDevicesTs.hasOwnProperty("battery_type")) {
      var value = state.homeDevicesTs.battery_type[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      switch (parseInt(value)) {
        case 1: //铅酸电池
          value = "Lead-acid battery";
          break;
        case 2: //镍锌电池
          value = "NiMH battery";
          break;
        case 3: //磷酸铁锂电池
          value = "Lithium iron phosphate battery";
          break;
        case 4: //锰酸锂电池
          value = "Lithium manganate battery";
          break;
        case 5: //钴酸锂电池
          value = "Lithium cobalt oxide battery";
          break;
        case 6: //三元电池
          value = "Ternary battery";
          break;
        case 7: //聚合物电池
          value = "Polymer batteries";
          break;
        case 8: //钛酸锂电池
          value = "Lithium titanate battery";
          break;
        default:
          value = "undefined";
          break;
      }
      state.homeDevicesTs.battery_type[0].value = value;
    }

    // 10、capacity
    if (state.homeDevicesTs.hasOwnProperty("capacity")) {
      var value = state.homeDevicesTs.capacity[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.capacity[0].value = value;
    }

    // 11、capacityRemain
    if (state.homeDevicesTs.hasOwnProperty("capacityRemain")) {
      var value = state.homeDevicesTs.capacityRemain[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.capacityRemain[0].value = value / 100;
    }

    // 12、cycleNum
    if (state.homeDevicesTs.hasOwnProperty("cycleNum")) {
      var value = state.homeDevicesTs.cycleNum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.cycleNum[0].value = value;
    }

    // 13、distance
    if (state.homeDevicesTs.hasOwnProperty("distance")) {
      var value = state.homeDevicesTs.distance[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null) {
        state.homeDevicesTs.distance[0].value = 0;
      } else {
        value = parseInt(value, 16);
        state.homeDevicesTs.distance[0].value = value;
      }
    }

    // 14、electricChargeSum
    if (state.homeDevicesTs.hasOwnProperty("electricChargeSum")) {
      var value = state.homeDevicesTs.electricChargeSum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null) {
        state.homeDevicesTs.electricChargeSum[0].value = null;
      } else {
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseFloat(value, 16);
        value = value / 10;
        state.homeDevicesTs.electricChargeSum[0].value = value;
      }
    }

    // 15、electricDischargeSum
    if (state.homeDevicesTs.hasOwnProperty("electricDischargeSum")) {
      var value = state.homeDevicesTs.electricDischargeSum[0].value;
      var first = value.charAt(0);
      if (first === "N") {
        value = value.substring(1, value.length);
        value = parseInt(value, 16);
        state.homeDevicesTs.electricDischargeSum[0].value = value;
      } else if (value == null) {
        state.homeDevicesTs.electricChargeSum[0].value = null;
      }
    }

    // 16、ewflag
    if (state.homeDevicesTs.hasOwnProperty("ewflag")) {
      var value = state.homeDevicesTs.ewflag[0].value;
      if (value === "N00") {
        state.homeDevicesTs.nsflag[0].value = "";
      } else {
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var i = 0; i < arr.length / 2; i++) {
          var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.homeDevicesTs.ewflag[0].value = out;
      }
    }

    // 17、firstError
    if (state.homeDevicesTs.hasOwnProperty("firstError")) {
      var value = state.homeDevicesTs.firstError[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var value10 = parseInt(value, 16);
      var meanings = [];
      var meaningsString = "";
      if (value10 === 0) {
        meaningsString = "暂无";
      } else {
        for (let i = 0; i < 32; i++) {
          // 使用位运算检查特定位是否为1
          if ((value10 & (1 << i)) !== 0) {
            switch (i) {
              case 0:
                meanings.push("总压过低报警");
                break;
              case 1:
                meanings.push("总压过高报警");
                break;
              case 2:
                meanings.push("单体欠压报警");
                break;
              case 3:
                meanings.push("单体过压报警");
                break;
              case 4:
                meanings.push("环境高温报警");
                break;
              case 5:
                meanings.push("环境低温报警");
                break;
              case 6:
                meanings.push("放电过流报警");
                break;
              case 7:
                meanings.push("充电过流报警");
                break;
              case 8:
                meanings.push("SOC低报警");
                break;
              case 9:
                meanings.push("压差过大报警");
                break;
              case 10:
                meanings.push("预留报警1");
                break;
              case 11:
                meanings.push("充电高温报警");
                break;
              case 12:
                meanings.push("充电低温报警");
                break;
              case 13:
                meanings.push("放电高温报警");
                break;
              case 14:
                meanings.push("放电低温报警");
                break;
              case 15:
                meanings.push("BMS短路报警");
                break;
              case 16:
                meanings.push("MOS高温报警");
                break;
              case 17:
                meanings.push("预留报警2");
                break;
              case 18:
                meanings.push("BMS闲置报警");
                break;
              case 19:
                meanings.push("BMS离线报警");
                break;
              case 20:
                meanings.push("超出电子围栏报警");
                break;
              case 21:
                meanings.push("BMS开盖报警");
                break;
              case 22:
                meanings.push("预留报警3");
                break;
              case 23:
                meanings.push("预留报警4");
                break;
              case 24:
                meanings.push("预留报警5");
                break;

              case 25:
                meanings.push("预留报警6");
                break;
              case 26:
                meanings.push("预留报警7");
                break;
              case 27:
                meanings.push("预留报警8");
                break;
              case 28:
                meanings.push("预留报警9");
                break;
              case 29:
                meanings.push("预留报警10");
                break;
              case 30:
                meanings.push("预留报警11");
                break;
              case 31:
                meanings.push("预留报警12");
                break;
            }
          }
        }
        meaningsString = meanings.join(", ");
      }

      state.homeDevicesTs.firstError[0].value = meaningsString;
    }

    // 18、gps_lps
    if (state.homeDevicesTs.hasOwnProperty("gps_lps")) {
      var value = state.homeDevicesTs.gps_lps[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      state.homeDevicesTs.gps_lps[0].value = value;
    }

    // 19、latitude
    if (state.homeDevicesTs.hasOwnProperty("latitude")) {
      var value = state.homeDevicesTs.latitude[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var hex = value;
      var arr = hex.split("");
      var out = "";
      for (var i = 0; i < arr.length / 2; i++) {
        var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
        var charValue = String.fromCharCode(tmp);
        out += charValue;
      }
      state.homeDevicesTs.latitude[0].value = parseFloat(out);
    }

    // 20、longitude
    if (state.homeDevicesTs.hasOwnProperty("longitude")) {
      var value = state.homeDevicesTs.longitude[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var hex = value;
      var arr = hex.split("");
      var out = "";
      for (var i = 0; i < arr.length / 2; i++) {
        var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
        var charValue = String.fromCharCode(tmp);
        out += charValue;
      }
      state.homeDevicesTs.longitude[0].value = parseFloat(out);
    }

    // 21、maxCellTempCellid
    if (state.homeDevicesTs.hasOwnProperty("maxCellTempCellid")) {
      var value = state.homeDevicesTs.maxCellTempCellid[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.maxCellTempCellid[0].value = value;
    }

    // 22、maxCellVoltage
    if (state.homeDevicesTs.hasOwnProperty("maxCellVoltage")) {
      var value = state.homeDevicesTs.maxCellVoltage[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.maxCellVoltage[0].value = value;
    }

    // 23、maxCellVoltageCellid
    if (state.homeDevicesTs.hasOwnProperty("maxCellVoltageCellid")) {
      var value = state.homeDevicesTs.maxCellVoltageCellid[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.maxCellVoltageCellid[0].value = value;
    }

    // 24、maxTemp
    if (state.homeDevicesTs.hasOwnProperty("maxTemp")) {
      var value = state.homeDevicesTs.maxTemp[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null || value == "") {
        state.homeDevicesTs.maxTemp[0].value = null;
      }
      value = parseInt(value, 16) - 40;
      state.homeDevicesTs.maxTemp[0].value = value;
    }

    // 25、minCellTempCellid
    if (state.homeDevicesTs.hasOwnProperty("minCellTempCellid")) {
      var value = state.homeDevicesTs.minCellTempCellid[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.minCellTempCellid[0].value = value;
    }

    // 26、minCellVoltage
    if (state.homeDevicesTs.hasOwnProperty("minCellVoltage")) {
      var value = state.homeDevicesTs.minCellVoltage[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.minCellVoltage[0].value = value;
    }

    // 27、minCellVoltageCellid
    if (state.homeDevicesTs.hasOwnProperty("minCellVoltageCellid")) {
      var value = state.homeDevicesTs.minCellVoltageCellid[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.minCellVoltageCellid[0].value = value;
    }

    // 28、minTemp
    if (state.homeDevicesTs.hasOwnProperty("minTemp")) {
      var value = state.homeDevicesTs.minTemp[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null || value == "") {
        state.homeDevicesTs.minTemp[0].value = null;
      }
      value = parseInt(value, 16) - 40;
      state.homeDevicesTs.minTemp[0].value = value;
    }

    // cellTempNum
    if (state.homeDevicesTs.hasOwnProperty("cellTempNum")) {
      var value = state.homeDevicesTs.cellTempNum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      state.homeDevicesTs.cellTempNum[0].value = value;
    }

    // celltemps
    if (state.homeDevicesTs.hasOwnProperty("celltemps")) {
      var value = state.homeDevicesTs.celltemps[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      let pairs = "";
      if (value == null || value == "") {
        pairs = null;
      } else {
        for (let i = 0; i < value.length; i += 2) {
          let pair = value.slice(i, i + 2);
          pair = parseInt(pair, 16) - 40;
          if (pairs === "") {
            pairs += pair;
          } else {
            pairs += ", " + pair;
          }
        }
      }
      state.homeDevicesTs.celltemps[0].value = pairs;
    }

    // envTempNum
    if (state.homeDevicesTs.hasOwnProperty("envTempNum")) {
      var value = state.homeDevicesTs.envTempNum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      state.homeDevicesTs.envTempNum[0].value = value;
    }

    // envtemps
    if (state.homeDevicesTs.hasOwnProperty("envtemps")) {
      var value = state.homeDevicesTs.envtemps[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      let pairs = "";
      if (value == null || value == "") {
        pairs = null;
      } else {
        for (let i = 0; i < value.length; i += 2) {
          let pair = value.slice(i, i + 2);
          pair = parseInt(pair, 16) - 40;
          if (pairs === "") {
            pairs += pair;
          } else {
            pairs += ", " + pair;
          }
        }
      }
      state.homeDevicesTs.envtemps[0].value = pairs;
    }

    // 29、mosSwitch
    if (state.homeDevicesTs.hasOwnProperty("mosSwitch")) {
      var value = state.homeDevicesTs.mosSwitch[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      // var meaning2 = "";
      // if (value === 0) {
      //   meaning2 = "充电MOS状态";
      // } else if (value === 1) {
      //   meaning2 = "放电MOS状态";
      // } else if (value === 2) {
      //   meaning2 = "预充MOS状态";
      // } else if (value === 3) {
      //   meaning2 = "加热MOS状态";
      // } else if (value === 4) {
      //   meaning2 = "蜂鸣器状态";
      // } else {
      //   meaning2 = "其它";
      // }
      state.homeDevicesTs.mosSwitch[0].value = value;
    }

    // mosTempNum
    if (state.homeDevicesTs.hasOwnProperty("mosTempNum")) {
      var value = state.homeDevicesTs.mosTempNum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      state.homeDevicesTs.mosTempNum[0].value = value;
    }

    // mostemps
    if (state.homeDevicesTs.hasOwnProperty("mostemps")) {
      var value = state.homeDevicesTs.mostemps[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      let pairs = "";
      if (value == null || value == "") {
        pairs = null;
      } else {
        for (let i = 0; i < value.length; i += 2) {
          let pair = value.slice(i, i + 2);
          pair = parseInt(pair, 16) - 40;
          if (pairs === "") {
            pairs += pair;
          } else {
            pairs += ", " + pair;
          }
        }
      }
      state.homeDevicesTs.mostemps[0].value = pairs;
    }

    // inputSwitch
    if (state.homeDevicesTs.hasOwnProperty("inputSwitch")) {
      var value = state.homeDevicesTs.inputSwitch[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16).toString(2);
      state.homeDevicesTs.inputSwitch[0].value = value;
    }
    // 30、nsflag
    if (state.homeDevicesTs.hasOwnProperty("nsflag")) {
      var value = state.homeDevicesTs.nsflag[0].value;
      if (value === "N00") {
        state.homeDevicesTs.nsflag[0].value = "";
      } else {
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var i = 0; i < arr.length / 2; i++) {
          var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.homeDevicesTs.nsflag[0].value = out;
      }
    }

    // 31、rackTotalCurrent
    if (state.homeDevicesTs.hasOwnProperty("rackTotalCurrent")) {
      var value = state.homeDevicesTs.rackTotalCurrent[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      value = parseFloat(value);
      value = value / 100 - 300;
      value = value.toFixed(2);
      state.homeDevicesTs.rackTotalCurrent[0].value = value;
    }

    // 32、rackTotalCurrent
    if (state.homeDevicesTs.hasOwnProperty("rackTotalVoltage")) {
      var value = state.homeDevicesTs.rackTotalVoltage[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      value = parseFloat(value);
      value = value / 100;
      state.homeDevicesTs.rackTotalVoltage[0].value = value;
    }

    // 33、racketSOC
    if (state.homeDevicesTs.hasOwnProperty("racketSOC")) {
      var value = state.homeDevicesTs.racketSOC[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.racketSOC[0].value = value;
    }

    // 34、racketSOH
    if (state.homeDevicesTs.hasOwnProperty("racketSOH")) {
      var value = state.homeDevicesTs.racketSOH[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.racketSOH[0].value = value;
    }

    // 35、racket_num
    if (state.homeDevicesTs.hasOwnProperty("racket_num")) {
      var value = state.homeDevicesTs.racket_num[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.racket_num[0].value = value;
    }

    // 36、secondError
    if (state.homeDevicesTs.hasOwnProperty("secondError")) {
      var value = state.homeDevicesTs.secondError[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var value10 = parseInt(value, 16);
      var meanings = [];
      var meaningsString = "";
      if (value10 === 0) {
        meaningsString = "暂无";
      } else {
        for (let i = 0; i < 32; i++) {
          // 使用位运算检查特定位是否为1
          if ((value10 & (1 << i)) !== 0) {
            switch (i) {
              case 0:
                meanings.push("总压过低报警");
                break;
              case 1:
                meanings.push("总压过高报警");
                break;
              case 2:
                meanings.push("单体欠压报警");
                break;
              case 3:
                meanings.push("单体过压报警");
                break;
              case 4:
                meanings.push("环境高温报警");
                break;
              case 5:
                meanings.push("环境低温报警");
                break;
              case 6:
                meanings.push("放电过流报警");
                break;
              case 7:
                meanings.push("充电过流报警");
                break;
              case 8:
                meanings.push("SOC低报警");
                break;
              case 9:
                meanings.push("压差过大报警");
                break;
              case 10:
                meanings.push("预留报警1");
                break;
              case 11:
                meanings.push("充电高温报警");
                break;
              case 12:
                meanings.push("充电低温报警");
                break;
              case 13:
                meanings.push("放电高温报警");
                break;
              case 14:
                meanings.push("放电低温报警");
                break;
              case 15:
                meanings.push("BMS短路报警");
                break;
              case 16:
                meanings.push("MOS高温报警");
                break;
              case 17:
                meanings.push("预留报警2");
                break;
              case 18:
                meanings.push("BMS闲置报警");
                break;
              case 19:
                meanings.push("BMS离线报警");
                break;
              case 20:
                meanings.push("超出电子围栏报警");
                break;
              case 21:
                meanings.push("BMS开盖报警");
                break;
              case 22:
                meanings.push("预留报警3");
                break;
              case 23:
                meanings.push("预留报警4");
                break;
              case 24:
                meanings.push("预留报警5");
                break;

              case 25:
                meanings.push("预留报警6");
                break;
              case 26:
                meanings.push("预留报警7");
                break;
              case 27:
                meanings.push("预留报警8");
                break;
              case 28:
                meanings.push("预留报警9");
                break;
              case 29:
                meanings.push("预留报警10");
                break;
              case 30:
                meanings.push("预留报警11");
                break;
              case 31:
                meanings.push("预留报警12");
                break;
            }
          }
        }
        var meaningsString = meanings.join(", ");
      }
      state.homeDevicesTs.secondError[0].value = meaningsString;
    }

    // 37、signalIntensity
    if (state.homeDevicesTs.hasOwnProperty("signalIntensity")) {
      var value = state.homeDevicesTs.signalIntensity[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null || value == "") {
        state.homeDevicesTs.signalIntensity[0].value = "";
      } else {
        value = parseInt(value, 16);
        state.homeDevicesTs.signalIntensity[0].value = value;
      }
    }

    // 38、speed
    if (state.homeDevicesTs.hasOwnProperty("speed")) {
      var value = state.homeDevicesTs.speed[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      if (value == null || value == "") {
        state.homeDevicesTs.speed[0].value = "";
      } else {
        value = parseInt(value, 16);
        state.homeDevicesTs.speed[0].value = value;
      }
    }

    // volsNum
    if (state.homeDevicesTs.hasOwnProperty("volsNum")) {
      var value = state.homeDevicesTs.volsNum[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 16);
      state.homeDevicesTs.volsNum[0].value = value;
      var str = "";
      if (state.homeDevicesTs.hasOwnProperty("v0")) {
        for (let i = 0; i < value; i++) {
          const vKey = "v" + i;
          var value1 = state.homeDevicesTs[vKey][0].value;
          var first = value1.charAt(0);
          if (first == "N") {
            value1 = value1.substring(1, value1.length);
          }
          // value1 = parseInt(value1, 16);
          state.homeDevicesTs[vKey][0].value = value1;
          str += value1.toString() + ", ";
        }
      }
      if (str.endsWith(" ")) {
        str = str.slice(0, -2);
      }
      state.homeDevicesTs.volsNum[0].ts = str;
    }
    // Reverse1
    if (state.homeDevicesTs.hasOwnProperty("Reverse1")) {
      var value = state.homeDevicesTs.Reverse1[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      // value = parseInt(value, 16);
      state.homeDevicesTs.Reverse1[0].value = value;
    }
    // Reverse2
    if (state.homeDevicesTs.hasOwnProperty("Reverse2")) {
      var value = state.homeDevicesTs.Reverse2[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      // value = parseInt(value, 16);
      state.homeDevicesTs.Reverse2[0].value = value;
    }
    // Reverse3
    if (state.homeDevicesTs.hasOwnProperty("Reverse3")) {
      var value = state.homeDevicesTs.Reverse3[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      // value = parseInt(value, 16);
      state.homeDevicesTs.Reverse3[0].value = value;
    }
    // Reverse4
    if (state.homeDevicesTs.hasOwnProperty("Reverse4")) {
      var value = state.homeDevicesTs.Reverse4[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      // value = parseInt(value, 16);
      state.homeDevicesTs.Reverse4[0].value = value;
    }
    // Reverse5
    if (state.homeDevicesTs.hasOwnProperty("Reverse5")) {
      var value = state.homeDevicesTs.Reverse5[0].value;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      // value = parseInt(value, 16);
      state.homeDevicesTs.Reverse5[0].value = value;
    }
    return state.homeDevicesTs || [];
  },
  customerDevicesList(state) {
    return state.customerDevicesList || [];
  },
  customerDevicesInfo(state) {
    for (let i = 0; i < state.customerDevicesInfo.length; i++) {
      state.customerDevicesInfo[i].customerTitle =
        state.customerDevicesInfo.customerTitle;
      const date = new Date(state.customerDevicesInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.customerDevicesInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.customerDevicesInfo || [];
  },
  deviceTs(state) {
    // 2、Battery_Status
    if (state.deviceTs.hasOwnProperty("Battery_Status")) {
      for (var i = 0; i < state.deviceTs.Battery_Status.length; i++) {
        var value = state.deviceTs.Battery_Status[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.Battery_Status[i].value = value;
      }
    }

    // chargeFlag
    if (state.deviceTs.hasOwnProperty("chargeFlag")) {
      for (var i = 0; i < state.deviceTs.chargeFlag.length; i++) {
        var value = state.deviceTs.chargeFlag[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.deviceTs.chargeFlag[i].value = value;
      }
    }

    // 8、altitude
    if (state.deviceTs.hasOwnProperty("altitude")) {
      for (var i = 0; i < state.deviceTs.altitude.length; i++) {
        var value = state.deviceTs.altitude[i].value;
        if (value === "0") {
          state.deviceTs.altitude[i].value = 0;
        } else {
          var first = value.charAt(0);
          if (first == "N") {
            value = value.substring(1, value.length);
          }
          value = parseInt(value, 16);
          state.deviceTs.altitude[i].value = value;
        }
      }
    }

    // 9、battery_type
    if (state.deviceTs.hasOwnProperty("battery_type")) {
      for (var i = 0; i < state.deviceTs.battery_type.length; i++) {
        var value = state.deviceTs.battery_type[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        switch (parseInt(value)) {
          case 1: //铅酸电池
            value = "Lead-acid battery";
            break;
          case 2: //镍锌电池
            value = "NiMH battery";
            break;
          case 3: //磷酸铁锂电池
            value = "Lithium iron phosphate battery";
            break;
          case 4: //锰酸锂电池
            value = "Lithium manganate battery";
            break;
          case 5: //钴酸锂电池
            value = "Lithium cobalt oxide battery";
            break;
          case 6: //三元电池
            value = "Ternary battery";
            break;
          case 7: //聚合物电池
            value = "Polymer batteries";
            break;
          case 8: //钛酸锂电池
            value = "Lithium titanate battery";
            break;
          default:
            value = "undefined";
            break;
        }
        state.deviceTs.battery_type[i].value = value;
      }
    }

    // 10、capacity
    if (state.deviceTs.hasOwnProperty("capacity")) {
      for (var i = 0; i < state.deviceTs.capacity.length; i++) {
        var value = state.deviceTs.capacity[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        state.deviceTs.capacity[i].value = value;
      }
    }

    // 11、capacityRemain
    if (state.deviceTs.hasOwnProperty("capacityRemain")) {
      for (var i = 0; i < state.deviceTs.capacityRemain.length; i++) {
        var value = state.deviceTs.capacityRemain[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.capacityRemain[i].value = value / 100;
      }
    }

    // 12、cycleNum
    if (state.deviceTs.hasOwnProperty("cycleNum")) {
      for (var i = 0; i < state.deviceTs.cycleNum.length; i++) {
        var value = state.deviceTs.cycleNum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.cycleNum[i].value = value;
      }
    }

    // 13、distance
    if (state.deviceTs.hasOwnProperty("distance")) {
      for (var i = 0; i < state.deviceTs.distance.length; i++) {
        var value = state.deviceTs.distance[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null) {
          state.deviceTs.distance[i].value = 0;
        } else {
          value = parseInt(value, 16);
          state.deviceTs.distance[i].value = value;
        }
      }
    }

    // 14、electricChargeSum
    if (state.deviceTs.hasOwnProperty("electricChargeSum")) {
      for (var i = 0; i < state.deviceTs.electricChargeSum.length; i++) {
        var value = state.deviceTs.electricChargeSum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null) {
          state.deviceTs.electricChargeSum[i].value = null;
        } else {
          if (first == "N") {
            value = value.substring(1, value.length);
          }
          value = parseFloat(value, 16);
          value = value / 10;
          state.deviceTs.electricChargeSum[i].value = value;
        }
      }
    }

    // 15、electricDischargeSum
    if (state.deviceTs.hasOwnProperty("electricDischargeSum")) {
      for (var i = 0; i < state.deviceTs.electricDischargeSum.length; i++) {
        var value = state.deviceTs.electricDischargeSum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
          value = value.substring(1, value.length);
          value = parseInt(value, 16);
          state.deviceTs.electricDischargeSum[i].value = value;
        } else if (value == null) {
          state.deviceTs.electricChargeSum[i].value = null;
        }
      }
    }

    // 16、ewflag
    if (state.deviceTs.hasOwnProperty("ewflag")) {
      for (var i = 0; i < state.deviceTs.ewflag.length; i++) {
        var value = state.deviceTs.ewflag[i].value;
        if (value === "N00") {
          state.deviceTs.nsflag[0].value = "";
        } else {
          var first = value.charAt(0);
          if (first == "N") {
            value = value.substring(1, value.length);
          }
          var hex = value;
          var arr = hex.split("");
          var out = "";
          for (var j = 0; j < arr.length / 2; j++) {
            var tmp = "0x" + arr[j * 2] + arr[j * 2 + 1];
            var charValue = String.fromCharCode(tmp);
            out += charValue;
          }
          state.deviceTs.ewflag[i].value = out;
        }
      }
    }

    // 17、firstError
    if (state.deviceTs.hasOwnProperty("firstError")) {
      for (var i = 0; i < state.deviceTs.firstError.length; i++) {
        var value = state.deviceTs.firstError[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }

        state.deviceTs.firstError[i].value = meaningsString;
      }
    }

    // 18、gps_lps
    if (state.deviceTs.hasOwnProperty("gps_lps")) {
      for (var i = 0; i < state.deviceTs.gps_lps.length; i++) {
        var value = state.deviceTs.gps_lps[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        state.deviceTs.gps_lps[i].value = value;
      }
    }

    // 19、latitude
    if (state.deviceTs.hasOwnProperty("latitude")) {
      for (var i = 0; i < state.deviceTs.latitude.length; i++) {
        var value = state.deviceTs.latitude[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var j = 0; j < arr.length / 2; j++) {
          var tmp = "0x" + arr[j * 2] + arr[j * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.deviceTs.latitude[i].value = parseFloat(out);
      }
    }

    // 20、longitude
    if (state.deviceTs.hasOwnProperty("longitude")) {
      for (var i = 0; i < state.deviceTs.longitude.length; i++) {
        var value = state.deviceTs.longitude[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var hex = value;
        var arr = hex.split("");
        var out = "";
        for (var j = 0; j < arr.length / 2; j++) {
          var tmp = "0x" + arr[j * 2] + arr[j * 2 + 1];
          var charValue = String.fromCharCode(tmp);
          out += charValue;
        }
        state.deviceTs.longitude[i].value = parseFloat(out);
      }
    }

    // 21、maxCellTempCellid
    if (state.deviceTs.hasOwnProperty("maxCellTempCellid")) {
      for (var i = 0; i < state.deviceTs.maxCellTempCellid.length; i++) {
        var value = state.deviceTs.maxCellTempCellid[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.maxCellTempCellid[i].value = value;
      }
    }

    // 22、maxCellVoltage
    if (state.deviceTs.hasOwnProperty("maxCellVoltage")) {
      for (var i = 0; i < state.deviceTs.maxCellVoltage.length; i++) {
        var value = state.deviceTs.maxCellVoltage[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.maxCellVoltage[i].value = value;
      }
    }

    // 23、maxCellVoltageCellid
    if (state.deviceTs.hasOwnProperty("maxCellVoltageCellid")) {
      for (var i = 0; i < state.deviceTs.maxCellVoltageCellid.length; i++) {
        var value = state.deviceTs.maxCellVoltageCellid[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.maxCellVoltageCellid[i].value = value;
      }
    }

    // 24、maxTemp
    if (state.deviceTs.hasOwnProperty("maxTemp")) {
      for (var i = 0; i < state.deviceTs.maxTemp.length; i++) {
        var value = state.deviceTs.maxTemp[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null || value == "") {
          state.deviceTs.maxTemp[i].value = null;
        }
        value = parseInt(value, 16) - 40;
        state.deviceTs.maxTemp[i].value = value;
      }
    }

    // 25、minCellTempCellid
    if (state.deviceTs.hasOwnProperty("minCellTempCellid")) {
      for (var i = 0; i < state.deviceTs.minCellTempCellid.length; i++) {
        var value = state.deviceTs.minCellTempCellid[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.minCellTempCellid[i].value = value;
      }
    }

    // 26、minCellVoltage
    if (state.deviceTs.hasOwnProperty("minCellVoltage")) {
      for (var i = 0; i < state.deviceTs.minCellVoltage.length; i++) {
        var value = state.deviceTs.minCellVoltage[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.minCellVoltage[i].value = value;
      }
    }

    // 27、minCellVoltageCellid
    if (state.deviceTs.hasOwnProperty("minCellVoltageCellid")) {
      for (var i = 0; i < state.deviceTs.minCellVoltageCellid.length; i++) {
        var value = state.deviceTs.minCellVoltageCellid[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.minCellVoltageCellid[i].value = value;
      }
    }

    // 28、minTemp
    if (state.deviceTs.hasOwnProperty("minTemp")) {
      for (var i = 0; i < state.deviceTs.minTemp.length; i++) {
        var value = state.deviceTs.minTemp[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null || value == "") {
          state.deviceTs.minTemp[i].value = null;
        }
        value = parseInt(value, 16) - 40;
        state.deviceTs.minTemp[i].value = value;
      }
    }
    // cellTempNum
    if (state.deviceTs.hasOwnProperty("cellTempNum")) {
      for (var i = 0; i < state.deviceTs.cellTempNum.length; i++) {
        var value = state.deviceTs.cellTempNum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.deviceTs.cellTempNum[i].value = value;
      }
    }

    // celltemps
    if (state.deviceTs.hasOwnProperty("celltemps")) {
      for (var i = 0; i < state.deviceTs.celltemps.length; i++) {
        var value = state.deviceTs.celltemps[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.deviceTs.celltemps[i].value = pairs;
      }
    }

    // envTempNum
    if (state.deviceTs.hasOwnProperty("envTempNum")) {
      for (var i = 0; i < state.deviceTs.envTempNum.length; i++) {
        var value = state.deviceTs.envTempNum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.deviceTs.envTempNum[i].value = value;
      }
    }

    // envtemps
    if (state.deviceTs.hasOwnProperty("envtemps")) {
      for (var i = 0; i < state.deviceTs.envtemps.length; i++) {
        var value = state.deviceTs.envtemps[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.deviceTs.envtemps[i].value = pairs;
      }
    }

    // 29、mosSwitch
    if (state.deviceTs.hasOwnProperty("mosSwitch")) {
      for (var i = 0; i < state.deviceTs.mosSwitch.length; i++) {
        var value = state.deviceTs.mosSwitch[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.deviceTs.mosSwitch[i].value = value;
      }
    }
    // mosTempNum
    if (state.deviceTs.hasOwnProperty("mosTempNum")) {
      for (var i = 0; i < state.deviceTs.mosTempNum.length; i++) {
        var value = state.deviceTs.mosTempNum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.deviceTs.mosTempNum[i].value = value;
      }
    }

    // mostemps
    if (state.deviceTs.hasOwnProperty("mostemps")) {
      for (var i = 0; i < state.deviceTs.mostemps.length; i++) {
        var value = state.deviceTs.mostemps[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.deviceTs.mostemps[i].value = pairs;
      }
    }
    // inputSwitch
    if (state.deviceTs.hasOwnProperty("inputSwitch")) {
      for (var i = 0; i < state.deviceTs.inputSwitch.length; i++) {
        var value = state.deviceTs.inputSwitch[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16).toString(2);
        state.deviceTs.inputSwitch[i].value = value;
      }
    }
    // 30、nsflag
    if (state.deviceTs.hasOwnProperty("nsflag")) {
      for (var i = 0; i < state.deviceTs.nsflag.length; i++) {
        var value = state.deviceTs.nsflag[i].value;
        if (value === "N00") {
          state.deviceTs.nsflag[i].value = "";
        } else {
          var first = value.charAt(0);
          if (first == "N") {
            value = value.substring(1, value.length);
          }
          var hex = value;
          var arr = hex.split("");
          var out = "";
          for (var j = 0; j < arr.length / 2; j++) {
            var tmp = "0x" + arr[j * 2] + arr[j * 2 + 1];
            var charValue = String.fromCharCode(tmp);
            out += charValue;
          }
          state.deviceTs.nsflag[i].value = out;
        }
      }
    }

    // 31、rackTotalCurrent
    if (state.deviceTs.hasOwnProperty("rackTotalCurrent")) {
      for (var i = 0; i < state.deviceTs.rackTotalCurrent.length; i++) {
        var value = state.deviceTs.rackTotalCurrent[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        value = parseFloat(value);
        value = value / 100 - 300;
        value = value.toFixed(2);
        state.deviceTs.rackTotalCurrent[i].value = value;
      }
    }

    // 32、rackTotalCurrent
    if (state.deviceTs.hasOwnProperty("rackTotalVoltage")) {
      for (var i = 0; i < state.deviceTs.rackTotalVoltage.length; i++) {
        var value = state.deviceTs.rackTotalVoltage[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        value = parseFloat(value);
        value = value / 100;
        state.deviceTs.rackTotalVoltage[i].value = value;
      }
    }

    // 33、racketSOC
    if (state.deviceTs.hasOwnProperty("racketSOC")) {
      for (var i = 0; i < state.deviceTs.racketSOC.length; i++) {
        var value = state.deviceTs.racketSOC[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.racketSOC[i].value = value;
      }
    }

    // 34、racketSOH
    if (state.deviceTs.hasOwnProperty("racketSOH")) {
      for (var i = 0; i < state.deviceTs.racketSOH.length; i++) {
        var value = state.deviceTs.racketSOH[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.racketSOH[i].value = value;
      }
    }

    // 35、racket_num
    if (state.deviceTs.hasOwnProperty("racket_num")) {
      for (var i = 0; i < state.deviceTs.racket_num.length; i++) {
        var value = state.deviceTs.racket_num[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.racket_num[i].value = value;
      }
    }

    // 36、secondError
    if (state.deviceTs.hasOwnProperty("secondError")) {
      for (var i = 0; i < state.deviceTs.secondError.length; i++) {
        var value = state.deviceTs.secondError[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }
        state.deviceTs.secondError[i].value = meaningsString;
      }
    }

    // 37、signalIntensity
    if (state.deviceTs.hasOwnProperty("signalIntensity")) {
      for (var i = 0; i < state.deviceTs.signalIntensity.length; i++) {
        var value = state.deviceTs.signalIntensity[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null || value == "") {
          state.deviceTs.signalIntensity[0].value = "";
        } else {
          value = parseInt(value, 16);
          state.deviceTs.signalIntensity[i].value = value;
        }
      }
    }

    // 38、speed
    if (state.deviceTs.hasOwnProperty("speed")) {
      for (var i = 0; i < state.deviceTs.speed.length; i++) {
        var value = state.deviceTs.speed[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        if (value == null || value == "") {
          state.deviceTs.speed[i].value = "";
        } else {
          value = parseInt(value, 16);
          state.deviceTs.speed[i].value = value;
        }
      }
    }

    // vs
    if (state.deviceTs.hasOwnProperty("vs")) {
      for (var i = 0; i < state.deviceTs.vs.length; i++) {
        var value = state.deviceTs.vs[i].value;
        var value1 = value.split(",");
        var value2 = value1.join(", ");
        state.deviceTs.vs[i].value = value2;
      }
    }

    // volsNum
    if (state.deviceTs.hasOwnProperty("volsNum")) {
      for (var i = 0; i < state.deviceTs.volsNum.length; i++) {
        var value = state.deviceTs.volsNum[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16);
        state.deviceTs.volsNum[i].value = value;
      }
    }

    // Reverse1
    if (state.deviceTs.hasOwnProperty("Reverse1")) {
      for (var i = 0; i < state.deviceTs.Reverse1.length; i++) {
        var value = state.deviceTs.Reverse1[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        // value = parseInt(value, 16);
        state.deviceTs.Reverse1[i].value = value;
      }
    }
    // Reverse2
    if (state.deviceTs.hasOwnProperty("Reverse2")) {
      for (var i = 0; i < state.deviceTs.Reverse2.length; i++) {
        var value = state.deviceTs.Reverse2[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        // value = parseInt(value, 16);
        state.deviceTs.Reverse2[i].value = value;
      }
    }
    // Reverse3
    if (state.deviceTs.hasOwnProperty("Reverse3")) {
      for (var i = 0; i < state.deviceTs.Reverse3.length; i++) {
        var value = state.deviceTs.Reverse3[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        // value = parseInt(value, 16);
        state.deviceTs.Reverse3[i].value = value;
      }
    }
    // Reverse4
    if (state.deviceTs.hasOwnProperty("Reverse4")) {
      for (var i = 0; i < state.deviceTs.Reverse4.length; i++) {
        var value = state.deviceTs.Reverse4[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        // value = parseInt(value, 16);
        state.deviceTs.Reverse4[i].value = value;
      }
    }
    // Reverse5
    if (state.deviceTs.hasOwnProperty("Reverse5")) {
      for (var i = 0; i < state.deviceTs.Reverse5.length; i++) {
        var value = state.deviceTs.Reverse5[i].value;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        // value = parseInt(value, 16);
        state.deviceTs.Reverse5[i].value = value;
      }
    }

    return state.deviceTs || [];
  },
  devicesFindLocal(state) {
    var newArr = [];
    for (let i = 0; i < state.devicesFindLocal.length; i++) {
      const deviceInfo = state.devicesFindLocal[i];
      var obj = {
        name: state.devicesFindLocal[i].latest.ENTITY_FIELD.name.value,
        lat: state.devicesFindLocal[i].latest.TIME_SERIES.lat.value,
        lon: state.devicesFindLocal[i].latest.TIME_SERIES.lon.value,
      };
      newArr.push(obj);
    }
    state.devicesFindLocal = newArr;
    return state.devicesFindLocal || [];
  },
  deviceNameFindByNumber(state) {
    return state.deviceNameFindByNumber || "";
  },
  allDevicesB1(state) {
    for (let i = 0; i < state.allDevicesB1.devices.length; i++) {
      const date = new Date(state.allDevicesB1.devices[i].tsB1);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.allDevicesB1.devices[i].tsB1 =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;

      // 17、firstError
      if (state.allDevicesB1.devices[i].hasOwnProperty("firstError")) {
        var value = state.allDevicesB1.devices[i].firstError;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }

        state.allDevicesB1.devices[i].firstError = meaningsString;
      }
      // cellTempNum
      if (state.allDevicesB1.devices[i].hasOwnProperty("cellTempNum")) {
        var value = state.allDevicesB1.devices[i].cellTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.allDevicesB1.devices[i].cellTempNum = value;
      }

      // celltemps
      if (state.allDevicesB1.devices[i].hasOwnProperty("celltemps")) {
        var value = state.allDevicesB1.devices[i].celltemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.allDevicesB1.devices[i].celltemps = pairs;
      }
      // envTempNum
      if (state.allDevicesB1.devices[i].hasOwnProperty("envTempNum")) {
        var value = state.allDevicesB1.devices[i].envTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.allDevicesB1.devices[i].envTempNum = value;
      }

      // envtemps
      if (state.allDevicesB1.devices[i].hasOwnProperty("envtemps")) {
        var value = state.allDevicesB1.devices[i].envtemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.allDevicesB1.devices[i].envtemps = pairs;
      }
      // 29、mosSwitch
      if (state.allDevicesB1.devices[i].hasOwnProperty("mosSwitch")) {
        var value = state.allDevicesB1.devices[i].mosSwitch;

        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.allDevicesB1.devices[i].mosSwitch = value;
      }
      // mosTempNum
      if (state.allDevicesB1.devices[i].hasOwnProperty("mosTempNum")) {
        var value = state.allDevicesB1.devices[i].mosTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.allDevicesB1.devices[i].mosTempNum = value;
      }

      // mostemps
      if (state.allDevicesB1.devices[i].hasOwnProperty("mostemps")) {
        var value = state.allDevicesB1.devices[i].mostemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.allDevicesB1.devices[i].mostemps = pairs;
      }
      // inputSwitch
      if (state.allDevicesB1.devices[i].hasOwnProperty("inputSwitch")) {
        var value = state.allDevicesB1.devices[i].inputSwitch;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16).toString(2);
        state.allDevicesB1.devices[i].inputSwitch = value;
      }

      // 36、secondError
      if (state.allDevicesB1.devices[i].hasOwnProperty("secondError")) {
        var value = state.allDevicesB1.devices[i].secondError;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }
        state.allDevicesB1.devices[i].secondError = meaningsString;
      }

      // onOffStatus
      if (state.allDevicesB1.devices[i].hasOwnProperty("onOffStatus")) {
        var value = state.allDevicesB1.devices[i].onOffStatus;
        var meaning = "";
        if (value === -1) {
          meaning = "新增";
        } else if (value === 0) {
          meaning = "离线";
        } else if (value === 1) {
          meaning = "在线";
        } else if (value === 2) {
          meaning = "休眠";
        } else if (value === 3) {
          meaning = "馈电";
        } else if (value === 4) {
          meaning = "欠压";
        } else {
          meaning = "无";
        }
        state.allDevicesB1.devices[i].onOffStatus = meaning;
      }
    }
    return state.allDevicesB1 || [];
  },
  findDevicesB1(state) {
    if (state.findDevicesB1.hasOwnProperty("tsB1")) {
      const date = new Date(state.findDevicesB1.tsB1);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.findDevicesB1.tsB1 =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    // onOffStatus
    if (state.findDevicesB1.hasOwnProperty("onOffStatus")) {
      var value = state.findDevicesB1.onOffStatus;
      var meaning = "";
      if (value === -1) {
        meaning = "新增";
      } else if (value === 0) {
        meaning = "离线";
      } else if (value === 1) {
        meaning = "在线";
      } else if (value === 2) {
        meaning = "休眠";
      } else if (value === 3) {
        meaning = "馈电";
      } else if (value === 4) {
        meaning = "欠压";
      } else {
        meaning = "无";
      }
      state.findDevicesB1.onOffStatus = meaning;
    }
    // 17、firstError
    if (state.findDevicesB1.hasOwnProperty("firstError")) {
      var value = state.findDevicesB1.firstError;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var value10 = parseInt(value, 16);
      var meanings = [];
      var meaningsString = "";
      if (value10 === 0) {
        meaningsString = "暂无";
      } else {
        for (let i = 0; i < 32; i++) {
          // 使用位运算检查特定位是否为1
          if ((value10 & (1 << i)) !== 0) {
            switch (i) {
              case 0:
                meanings.push("总压过低报警");
                break;
              case 1:
                meanings.push("总压过高报警");
                break;
              case 2:
                meanings.push("单体欠压报警");
                break;
              case 3:
                meanings.push("单体过压报警");
                break;
              case 4:
                meanings.push("环境高温报警");
                break;
              case 5:
                meanings.push("环境低温报警");
                break;
              case 6:
                meanings.push("放电过流报警");
                break;
              case 7:
                meanings.push("充电过流报警");
                break;
              case 8:
                meanings.push("SOC低报警");
                break;
              case 9:
                meanings.push("压差过大报警");
                break;
              case 10:
                meanings.push("预留报警1");
                break;
              case 11:
                meanings.push("充电高温报警");
                break;
              case 12:
                meanings.push("充电低温报警");
                break;
              case 13:
                meanings.push("放电高温报警");
                break;
              case 14:
                meanings.push("放电低温报警");
                break;
              case 15:
                meanings.push("BMS短路报警");
                break;
              case 16:
                meanings.push("MOS高温报警");
                break;
              case 17:
                meanings.push("预留报警2");
                break;
              case 18:
                meanings.push("BMS闲置报警");
                break;
              case 19:
                meanings.push("BMS离线报警");
                break;
              case 20:
                meanings.push("超出电子围栏报警");
                break;
              case 21:
                meanings.push("BMS开盖报警");
                break;
              case 22:
                meanings.push("预留报警3");
                break;
              case 23:
                meanings.push("预留报警4");
                break;
              case 24:
                meanings.push("预留报警5");
                break;

              case 25:
                meanings.push("预留报警6");
                break;
              case 26:
                meanings.push("预留报警7");
                break;
              case 27:
                meanings.push("预留报警8");
                break;
              case 28:
                meanings.push("预留报警9");
                break;
              case 29:
                meanings.push("预留报警10");
                break;
              case 30:
                meanings.push("预留报警11");
                break;
              case 31:
                meanings.push("预留报警12");
                break;
            }
          }
        }
        var meaningsString = meanings.join(", ");
      }

      state.findDevicesB1.firstError = meaningsString;
    }
    // 36、secondError
    if (state.findDevicesB1.hasOwnProperty("secondError")) {
      var value = state.findDevicesB1.secondError;
      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      var value10 = parseInt(value, 16);
      var meanings = [];
      var meaningsString = "";
      if (value10 === 0) {
        meaningsString = "暂无";
      } else {
        for (let i = 0; i < 32; i++) {
          // 使用位运算检查特定位是否为1
          if ((value10 & (1 << i)) !== 0) {
            switch (i) {
              case 0:
                meanings.push("总压过低报警");
                break;
              case 1:
                meanings.push("总压过高报警");
                break;
              case 2:
                meanings.push("单体欠压报警");
                break;
              case 3:
                meanings.push("单体过压报警");
                break;
              case 4:
                meanings.push("环境高温报警");
                break;
              case 5:
                meanings.push("环境低温报警");
                break;
              case 6:
                meanings.push("放电过流报警");
                break;
              case 7:
                meanings.push("充电过流报警");
                break;
              case 8:
                meanings.push("SOC低报警");
                break;
              case 9:
                meanings.push("压差过大报警");
                break;
              case 10:
                meanings.push("预留报警1");
                break;
              case 11:
                meanings.push("充电高温报警");
                break;
              case 12:
                meanings.push("充电低温报警");
                break;
              case 13:
                meanings.push("放电高温报警");
                break;
              case 14:
                meanings.push("放电低温报警");
                break;
              case 15:
                meanings.push("BMS短路报警");
                break;
              case 16:
                meanings.push("MOS高温报警");
                break;
              case 17:
                meanings.push("预留报警2");
                break;
              case 18:
                meanings.push("BMS闲置报警");
                break;
              case 19:
                meanings.push("BMS离线报警");
                break;
              case 20:
                meanings.push("超出电子围栏报警");
                break;
              case 21:
                meanings.push("BMS开盖报警");
                break;
              case 22:
                meanings.push("预留报警3");
                break;
              case 23:
                meanings.push("预留报警4");
                break;
              case 24:
                meanings.push("预留报警5");
                break;

              case 25:
                meanings.push("预留报警6");
                break;
              case 26:
                meanings.push("预留报警7");
                break;
              case 27:
                meanings.push("预留报警8");
                break;
              case 28:
                meanings.push("预留报警9");
                break;
              case 29:
                meanings.push("预留报警10");
                break;
              case 30:
                meanings.push("预留报警11");
                break;
              case 31:
                meanings.push("预留报警12");
                break;
            }
          }
        }
        var meaningsString = meanings.join(", ");
      }
      state.findDevicesB1.secondError = meaningsString;
    }
    // 29、mosSwitch
    if (state.findDevicesB1.hasOwnProperty("mosSwitch")) {
      var value = state.findDevicesB1.mosSwitch;

      var first = value.charAt(0);
      if (first == "N") {
        value = value.substring(1, value.length);
      }
      value = parseInt(value, 10);
      state.findDevicesB1.mosSwitch = value;
    }
    return state.findDevicesB1 || [];
  },
  findErrorDevices(state) {
    for (let i = 0; i < state.findErrorDevices.data.length; i++) {
      const date = new Date(state.findErrorDevices.data[i].tsB1);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.findErrorDevices.data[i].tsB1 =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;

      // 17、firstError
      if (state.findErrorDevices.data[i].hasOwnProperty("firstError")) {
        var value = state.findErrorDevices.data[i].firstError;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }

        state.findErrorDevices.data[i].firstError = meaningsString;
      }
      // cellTempNum
      if (state.findErrorDevices.data[i].hasOwnProperty("cellTempNum")) {
        var value = state.findErrorDevices.data[i].cellTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.findErrorDevices.data[i].cellTempNum = value;
      }

      // celltemps
      if (state.findErrorDevices.data[i].hasOwnProperty("celltemps")) {
        var value = state.findErrorDevices.data[i].celltemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.findErrorDevices.data[i].celltemps = pairs;
      }
      // envTempNum
      if (state.findErrorDevices.data[i].hasOwnProperty("envTempNum")) {
        var value = state.findErrorDevices.data[i].envTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.findErrorDevices.data[i].envTempNum = value;
      }

      // envtemps
      if (state.findErrorDevices.data[i].hasOwnProperty("envtemps")) {
        var value = state.findErrorDevices.data[i].envtemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.findErrorDevices.data[i].envtemps = pairs;
      }
      // 29、mosSwitch
      if (state.findErrorDevices.data[i].hasOwnProperty("mosSwitch")) {
        var value = state.findErrorDevices.data[i].mosSwitch;

        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.findErrorDevices.data[i].mosSwitch = value;
      }
      // mosTempNum
      if (state.findErrorDevices.data[i].hasOwnProperty("mosTempNum")) {
        var value = state.findErrorDevices.data[i].mosTempNum;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 10);
        state.findErrorDevices.data[i].mosTempNum = value;
      }

      // mostemps
      if (state.findErrorDevices.data[i].hasOwnProperty("mostemps")) {
        var value = state.findErrorDevices.data[i].mostemps;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        let pairs = "";
        if (value == null || value == "") {
          pairs = null;
        } else {
          for (let i = 0; i < value.length; i += 2) {
            let pair = value.slice(i, i + 2);
            pair = parseInt(pair, 16) - 40;
            if (pairs === "") {
              pairs += pair;
            } else {
              pairs += ", " + pair;
            }
          }
        }
        state.findErrorDevices.data[i].mostemps = pairs;
      }
      // inputSwitch
      if (state.findErrorDevices.data[i].hasOwnProperty("inputSwitch")) {
        var value = state.findErrorDevices.data[i].inputSwitch;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        value = parseInt(value, 16).toString(2);
        state.findErrorDevices.data[i].inputSwitch = value;
      }

      // 36、secondError
      if (state.findErrorDevices.data[i].hasOwnProperty("secondError")) {
        var value = state.findErrorDevices.data[i].secondError;
        var first = value.charAt(0);
        if (first == "N") {
          value = value.substring(1, value.length);
        }
        var value10 = parseInt(value, 16);
        var meanings = [];
        var meaningsString = "";
        if (value10 === 0) {
          meaningsString = "暂无";
        } else {
          for (let i = 0; i < 32; i++) {
            // 使用位运算检查特定位是否为1
            if ((value10 & (1 << i)) !== 0) {
              switch (i) {
                case 0:
                  meanings.push("总压过低报警");
                  break;
                case 1:
                  meanings.push("总压过高报警");
                  break;
                case 2:
                  meanings.push("单体欠压报警");
                  break;
                case 3:
                  meanings.push("单体过压报警");
                  break;
                case 4:
                  meanings.push("环境高温报警");
                  break;
                case 5:
                  meanings.push("环境低温报警");
                  break;
                case 6:
                  meanings.push("放电过流报警");
                  break;
                case 7:
                  meanings.push("充电过流报警");
                  break;
                case 8:
                  meanings.push("SOC低报警");
                  break;
                case 9:
                  meanings.push("压差过大报警");
                  break;
                case 10:
                  meanings.push("预留报警1");
                  break;
                case 11:
                  meanings.push("充电高温报警");
                  break;
                case 12:
                  meanings.push("充电低温报警");
                  break;
                case 13:
                  meanings.push("放电高温报警");
                  break;
                case 14:
                  meanings.push("放电低温报警");
                  break;
                case 15:
                  meanings.push("BMS短路报警");
                  break;
                case 16:
                  meanings.push("MOS高温报警");
                  break;
                case 17:
                  meanings.push("预留报警2");
                  break;
                case 18:
                  meanings.push("BMS闲置报警");
                  break;
                case 19:
                  meanings.push("BMS离线报警");
                  break;
                case 20:
                  meanings.push("超出电子围栏报警");
                  break;
                case 21:
                  meanings.push("BMS开盖报警");
                  break;
                case 22:
                  meanings.push("预留报警3");
                  break;
                case 23:
                  meanings.push("预留报警4");
                  break;
                case 24:
                  meanings.push("预留报警5");
                  break;

                case 25:
                  meanings.push("预留报警6");
                  break;
                case 26:
                  meanings.push("预留报警7");
                  break;
                case 27:
                  meanings.push("预留报警8");
                  break;
                case 28:
                  meanings.push("预留报警9");
                  break;
                case 29:
                  meanings.push("预留报警10");
                  break;
                case 30:
                  meanings.push("预留报警11");
                  break;
                case 31:
                  meanings.push("预留报警12");
                  break;
              }
            }
          }
          var meaningsString = meanings.join(", ");
        }
        state.findErrorDevices.data[i].secondError = meaningsString;
      }

      // onOffStatus
      if (state.findErrorDevices.data[i].hasOwnProperty("onOffStatus")) {
        var value = state.findErrorDevices.data[i].onOffStatus;
        var meaning = "";
        if (value === -1) {
          meaning = "新增";
        } else if (value === 0) {
          meaning = "离线";
        } else if (value === 1) {
          meaning = "在线";
        } else if (value === 2) {
          meaning = "休眠";
        } else if (value === 3) {
          meaning = "馈电";
        } else if (value === 4) {
          meaning = "欠压";
        } else {
          meaning = "无";
        }
        state.findErrorDevices.data[i].onOffStatus = meaning;
      }
    }
    return state.findErrorDevices || [];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
